import React from 'react';
import { RandomCompany } from '../types/randomCompanies';
import { CompanyVoteCard } from './CompanyVoteCard';

interface RandomCompaniesGridProps {
  unvotedCompanies: RandomCompany[];
  votedCompanies: RandomCompany[];
  onVote: (companyId: string, companyName: string, vote: 'good' | 'bad', event?: React.MouseEvent) => void;
  hoveredGroupId?: string | null;
  onExpand?: (companyId: string) => void;
  onCloseOverlay?: () => void;
  onEdit?: (companyId: string) => void;
}

export const RandomCompaniesGrid: React.FC<RandomCompaniesGridProps> = ({
  unvotedCompanies,
  votedCompanies,
  onVote,
  hoveredGroupId,
  onExpand,
  onCloseOverlay,
  onEdit
}) => {
  const handleVote = (companyId: string, companyName: string, vote: 'good' | 'bad', targetCoords?: { x: number, y: number }) => {
    // Create a mock event with the target coordinates if provided
    const mockEvent = targetCoords ? {
      clientX: targetCoords.x,
      clientY: targetCoords.y
    } as React.MouseEvent : undefined;
    
    onVote(companyId, companyName, vote, mockEvent);
  };

  return (
    <>
      {/* Unvoted Companies Grid */}
      {unvotedCompanies.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {unvotedCompanies.map((company) => (
            <CompanyVoteCard
              key={company.id}
              company={company}
              onVote={handleVote}
              isHighlighted={hoveredGroupId === company.groupId}
              onExpand={onExpand}
              onCloseOverlay={onCloseOverlay}
              onEdit={onEdit}
            />
          ))}
        </div>
      )}

      {/* Voted Companies - Flex Layout for Natural Wrapping */}
      <div className="space-y-2" data-voted-section="true">
        {(votedCompanies.length > 0 || unvotedCompanies.length > 0) && (
          <>
            <div className="text-sm text-slate-400 font-medium">Categorized Companies:</div>
            <div className="flex flex-wrap gap-2 relative">
              {/* Actual voted companies */}
              {votedCompanies.map((company) => (
                <CompanyVoteCard
                  key={company.id}
                  company={company}
                  onVote={handleVote}
                  isHighlighted={hoveredGroupId === company.groupId}
                  onExpand={onExpand}
                  onCloseOverlay={onCloseOverlay}
                  onEdit={onEdit}
                />
              ))}
              
              {/* Pre-render future voted items invisibly to reserve space and get positions */}
              {unvotedCompanies.map((company) => (
                <CompanyVoteCard
                  key={`pre-${company.id}`}
                  company={{...company, voted: 'good'}} // Simulate as voted for positioning
                  onVote={() => {}} // No-op for pre-rendered items
                  isPreRender={true}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
}; 